import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/API_Client";

const ProtectedRoute = (props) => {
  const ProtRoute = props.ProtRoute;
  const Provider = props.Provider;
  const navigate = useNavigate();
  const { getUserDetails, isAuthorizedFeature, checkPermission } = useAuth();
  useEffect(() => {
    if (!getUserDetails()) {
      navigate("../");
    }
    if (props?.Permission != undefined) {
      checkPermission(props?.Permission);
    }

    if (props?.Feature !== undefined && !isAuthorizedFeature(props?.Feature)) {
      navigate("/accessDenied");
    }
  }, []);

  return (
    <>
      {
        Provider ? <Provider><ProtRoute {...props?.operationPermissions} /></Provider> : <ProtRoute {...props?.operationPermissions} />
      }
    </>
  );
};

export default ProtectedRoute;
